<template>
  <el-container class="container" id="recibo">
    <el-col
      :xs="24"
      :sm="22"
      :md="20"
      :lg="16"
      :xl="14"
    >
      <el-row
        class="hide-on-print"
        type="flex"
        justify="center"
      >
        <el-button @click="$goBack()" v-if="hasSearch">
          Volver
        </el-button>
        <router-link
          to="/busqueda-del-predio" style="margin-left: 10px"
          v-if="tipo !== 'avaluos'"
        >
          <el-button>
            Consultar otra cuenta
          </el-button>
        </router-link>
      </el-row>
      <el-col :span="24" class="frame-container">
        <iframe
          name=""
          class="doc"
          :src="base64"
          frameborder="0"
        />
      </el-col>
    </el-col>
  </el-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    base64: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      hasSearch: (state) => Boolean(state.predio?.user?.curt),
    }),
  },
};
</script>

<style lang="scss" scoped>
.frame-container {
  width: 100%;
  height: 100vh;
  margin-top: 30px;
  iframe {
    width: inherit;
    height: inherit;
  }
}
</style>
